import { create } from 'zustand';

export interface OnboardingSseStore {
  isConnected: boolean;
  lastEventId: string | undefined;
  setConnected: (connected: boolean) => void;
  setLastEventId: (id: string) => void;
}

export const useOnboardingSseStore = create<OnboardingSseStore>((set) => ({
  isConnected: false,
  lastEventId: undefined,
  setConnected: (connected) => set({ isConnected: connected }),
  setLastEventId: (id) => set({ lastEventId: id }),
}));
